module.exports = __webpack_public_path__ + "static/media/copy.e2b6090d.svg";